import { db } from '@services/firebase'
import { doc, onSnapshot } from 'firebase/firestore'

// Default offline fallback values
const DEFAULT_FLAGS = {
  ENABLE_EVENT_INTERACTIONS: false,
  ENABLE_GOOGLE_LOGIN: false,
  ENFORCE_FIRST_TICKET_OWNER: true,
  DISABLE_LAST_UNITS_BADGE: true,
  ENABLE_TICKET_EMAIL_NOTIFICATIONS: false,
  ENABLE_CHECKOUT_BENEFICIARY_SUMMARY: false,
  ENABLE_MAINTENANCE_MODE: false,
  DISABLE_PASSPORT_REGISTRATION: false,
  ENABLE_ROOT_EMAIL_VERIFICATION: false,
  ENABLE_AUTOMATIC_REFUND: false,
  REFUND_FEE_PERCENTAGE: 15,
};

// Global in-memory cache
export const featureFlags = { ...DEFAULT_FLAGS };

// Active live bindings
export let ENABLE_EVENT_INTERACTIONS = DEFAULT_FLAGS.ENABLE_EVENT_INTERACTIONS;
export let ENABLE_GOOGLE_LOGIN = DEFAULT_FLAGS.ENABLE_GOOGLE_LOGIN;
export let ENFORCE_FIRST_TICKET_OWNER = DEFAULT_FLAGS.ENFORCE_FIRST_TICKET_OWNER;
export let DISABLE_LAST_UNITS_BADGE = DEFAULT_FLAGS.DISABLE_LAST_UNITS_BADGE;
export let ENABLE_TICKET_EMAIL_NOTIFICATIONS = DEFAULT_FLAGS.ENABLE_TICKET_EMAIL_NOTIFICATIONS;
export let ENABLE_CHECKOUT_BENEFICIARY_SUMMARY = DEFAULT_FLAGS.ENABLE_CHECKOUT_BENEFICIARY_SUMMARY;
export let ENABLE_MAINTENANCE_MODE = DEFAULT_FLAGS.ENABLE_MAINTENANCE_MODE;
export let DISABLE_PASSPORT_REGISTRATION = DEFAULT_FLAGS.DISABLE_PASSPORT_REGISTRATION;
export let ENABLE_ROOT_EMAIL_VERIFICATION = DEFAULT_FLAGS.ENABLE_ROOT_EMAIL_VERIFICATION;
export let ENABLE_AUTOMATIC_REFUND = DEFAULT_FLAGS.ENABLE_AUTOMATIC_REFUND;
export let REFUND_FEE_PERCENTAGE = DEFAULT_FLAGS.REFUND_FEE_PERCENTAGE;

const listeners = new Set();

export const subscribeToFeatureFlags = (callback) => {
  listeners.add(callback);
  callback(featureFlags);
  return () => listeners.delete(callback);
};

// Start Firestore listener
// Determine collection based on current host URL
const isProductionDomain = window.location.hostname.includes('ingresso.arqzin.com') && !window.location.hostname.includes('dev.');
const COLLECTION_NAME = isProductionDomain ? 'feature_flags_prod' : 'feature_flags_dev';

console.log(`[FeatureFlags] Conectando a colecao: ${COLLECTION_NAME}`);

const docIds = Object.keys(DEFAULT_FLAGS);

docIds.forEach((flagId) => {
  const docRef = doc(db, COLLECTION_NAME, flagId);
  
  onSnapshot(docRef, (snapshot) => {
    if (snapshot.exists()) {
      const data = snapshot.data();
      if (data) {
        let val;
        if (typeof data.enabled === 'boolean') {
          val = data.enabled;
        } else if (data.value !== undefined) {
          val = data.value;
        }

        if (val !== undefined) {
          featureFlags[flagId] = val;

          // Update live binding references
          if (flagId === 'ENABLE_EVENT_INTERACTIONS') ENABLE_EVENT_INTERACTIONS = val;
          else if (flagId === 'ENABLE_GOOGLE_LOGIN') ENABLE_GOOGLE_LOGIN = val;
          else if (flagId === 'ENFORCE_FIRST_TICKET_OWNER') ENFORCE_FIRST_TICKET_OWNER = val;
          else if (flagId === 'DISABLE_LAST_UNITS_BADGE') DISABLE_LAST_UNITS_BADGE = val;
          else if (flagId === 'ENABLE_TICKET_EMAIL_NOTIFICATIONS') ENABLE_TICKET_EMAIL_NOTIFICATIONS = val;
          else if (flagId === 'ENABLE_CHECKOUT_BENEFICIARY_SUMMARY') ENABLE_CHECKOUT_BENEFICIARY_SUMMARY = val;
          else if (flagId === 'ENABLE_MAINTENANCE_MODE') ENABLE_MAINTENANCE_MODE = val;
          else if (flagId === 'DISABLE_PASSPORT_REGISTRATION') DISABLE_PASSPORT_REGISTRATION = val;
          else if (flagId === 'ENABLE_ROOT_EMAIL_VERIFICATION') ENABLE_ROOT_EMAIL_VERIFICATION = val;
          else if (flagId === 'ENABLE_AUTOMATIC_REFUND') ENABLE_AUTOMATIC_REFUND = val;
          else if (flagId === 'REFUND_FEE_PERCENTAGE') REFUND_FEE_PERCENTAGE = val;

          // Trigger react updates
          listeners.forEach((callback) => callback(featureFlags));
        }
      }
    }
  }, (error) => {
    console.warn(`[FeatureFlags] Erro ao carregar/escutar flag ${flagId}:`, error);
  });
});

export const isFeatureEnabled = (flagName) => {
  return featureFlags[flagName] === true;
};

export const getFeatureValue = (flagName, defaultValue = undefined) => {
  return featureFlags[flagName] !== undefined ? featureFlags[flagName] : defaultValue;
};
